import { redo, undo } from "prosemirror-history";
import { insertBreak } from "./commands/insertBreak";
import { Command } from "prosemirror-state";

export function buildKeymap(): Record<string, Command> {
	const result: Record<string, Command> = {
		"Enter": insertBreak,
		"Shift-Enter": insertBreak,
		"Mod-z": undo,
		"Shift-Mod-z": redo,
		"Ctrl-y": redo
	};

	return result;
}